const Dash = ({ colors: { fill, stroke } }) => (
  <g
    className="minute-marker"
    fill={fill}
    stroke={stroke}
    strokeLinecap="square"
  >
    <path
      strokeWidth={9.6}
      strokeLinejoin="bevel"
      d="M599.16 1021.2h1.68v16.8h-1.68z"
    />
    <path
      strokeWidth={2.4}
      strokeMiterlimit={2}
      d="m643.714 1024.09-1.756 16.709M686.949 1030.939l-3.493 16.433M729.23 1042.268l-5.19 15.978M770.097 1057.955l-6.833 15.348"
    />
    <path
      strokeWidth={9.6}
      strokeLinejoin="bevel"
      d="m808.673 1076.889 1.454.84-8.4 14.549-1.454-.84z"
    />
    <path
      strokeWidth={2.4}
      strokeMiterlimit={2}
      d="m845.812 1101.67-9.875 13.59M879.83 1129.217l-11.241 12.485M910.783 1160.17l-12.485 11.241M938.33 1194.188l-13.59 9.875"
    />
    <path
      strokeWidth={9.6}
      strokeLinejoin="bevel"
      d="m962.271 1229.873.84 1.454-14.549 8.4-.84-1.454z"
    />
    <path
      strokeWidth={2.4}
      strokeMiterlimit={2}
      d="m982.045 1269.903-15.348 6.833M997.732 1310.77l-15.978 5.19M1009.061 1353.051l-16.433 3.493M1015.91 1396.286l-16.709 1.756"
    />
    <path
      strokeWidth={9.6}
      strokeLinejoin="bevel"
      d="M1018.8 1439.16v1.68H1002v-1.68z"
    />
    <path
      strokeWidth={2.4}
      strokeMiterlimit={2}
      d="m1015.909 1483.714-16.708-1.756M1009.061 1526.949l-16.433-3.493M997.732 1569.23l-15.978-5.19M982.045 1610.097l-15.348-6.833"
    />
    <path
      strokeWidth={9.6}
      strokeLinejoin="bevel"
      d="m963.111 1648.673-.84 1.454-14.549-8.4.84-1.454z"
    />
    <path
      strokeWidth={2.4}
      strokeMiterlimit={2}
      d="m938.33 1685.812-13.59-9.875M910.783 1719.83l-12.485-11.241M879.83 1750.783l-11.241-12.485M845.812 1778.33l-9.875-13.59"
    />
    <path
      strokeWidth={9.6}
      strokeLinejoin="bevel"
      d="m810.127 1802.271-1.454.84-8.4-14.549 1.454-.84z"
    />
    <path
      strokeWidth={2.4}
      strokeMiterlimit={2}
      d="m770.097 1822.045-6.833-15.348M729.23 1837.732l-5.19-15.978M686.949 1849.061l-3.493-16.433M643.714 1855.91l-1.756-16.709"
    />
    <path
      strokeWidth={9.6}
      strokeLinejoin="bevel"
      d="M600.84 1858.8h-1.68V1842h1.68z"
    />
    <path
      strokeWidth={2.4}
      strokeMiterlimit={2}
      d="m556.286 1855.91 1.756-16.709M513.051 1849.061l3.493-16.433M470.77 1837.732l5.19-15.978M429.903 1822.045l6.833-15.348"
    />
    <path
      strokeWidth={9.6}
      strokeLinejoin="bevel"
      d="m391.327 1803.111-1.454-.84 8.4-14.549 1.454.84z"
    />
    <path
      strokeWidth={2.4}
      strokeMiterlimit={2}
      d="m354.188 1778.33 9.875-13.59M320.17 1750.783l11.24-12.485M289.217 1719.83l12.485-11.241M261.669 1685.812l13.592-9.875"
    />
    <path
      strokeWidth={9.6}
      strokeLinejoin="bevel"
      d="m237.729 1650.127-.84-1.454 14.549-8.4.84 1.454z"
    />
    <path
      strokeWidth={2.4}
      strokeMiterlimit={2}
      d="m217.955 1610.097 15.348-6.833M202.268 1569.23l15.978-5.19M190.939 1526.949l16.433-3.493M184.09 1483.714l16.709-1.756"
    />
    <path
      strokeWidth={9.6}
      strokeLinejoin="bevel"
      d="M181.2 1440.84v-1.68H198v1.68z"
    />
    <path
      strokeWidth={2.4}
      strokeMiterlimit={2}
      d="m184.09 1396.286 16.709 1.756M190.939 1353.051l16.433 3.493M202.268 1310.77l15.978 5.19M217.955 1269.903l15.348 6.833"
    />
    <path
      strokeWidth={9.6}
      strokeLinejoin="bevel"
      d="m236.889 1231.327.84-1.454 14.549 8.4-.84 1.454z"
    />
    <path
      strokeWidth={2.4}
      strokeMiterlimit={2}
      d="m261.67 1194.188 13.59 9.875M289.217 1160.17l12.485 11.241M320.17 1129.217l11.241 12.485M354.188 1101.67l9.875 13.59"
    />
    <path
      strokeWidth={9.6}
      strokeLinejoin="bevel"
      d="m389.873 1077.729 1.454-.84 8.4 14.549-1.454.84z"
    />
    <path
      strokeWidth={2.4}
      strokeMiterlimit={2}
      d="m429.903 1057.955 6.833 15.348M470.77 1042.268l5.19 15.978M513.051 1030.939l3.493 16.433M556.286 1024.09l1.756 16.709"
    />
  </g>
);

export default Dash;